import { Divider, Flex, Modal } from "antd";
import MainLayout from "../components/Layout/MainLayout";
import { MdEmail, MdMessage, MdMyLocation, MdOutlineEdit, MdOutlineUndo } from "react-icons/md";
import {
  PiBriefcaseFill,
  PiChatTextFill,
  PiEnvelope,
  PiEnvelopeFill,
  PiHashFill,
  PiHashStraightFill,
  PiIdentificationCard,
  PiIdentificationCardFill,
  PiMapPinAreaFill,
  PiMapPinSimpleLine,
  PiMapPinSimpleLineFill,
  PiPhoneFill,
  PiToolboxFill,
  PiUserFill,
  PiUserRectangleFill,
} from "react-icons/pi";
import { FaIdCard, FaPhone, FaUserAlt } from "react-icons/fa";
import InfoCard from "../common/InfoCard";
import { useDispatch, useSelector } from "react-redux";
import { resetState } from "../redux/auth/loginSlice";
import { resetData } from "../redux/auth/loginDataSlice";
import { Navigate, useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { createContext, use, useContext, useEffect, useMemo, useRef, useState } from "react";
import { useApiCall } from "../services/api";
import { FiPlus } from "react-icons/fi";
import { RiDeleteBin6Line } from "react-icons/ri";
import Block from "../components/models/Block";
import { useGlobalModal } from "../context/SuccessModalProvider";
import PartyCode from "../components/models/PartyCode";
import EditLogin from "../components/models/EditLogin";
import { deleteDefaultAddressMsg, modificationTitlesTags, variableType, PERMISSION_IDS } from "../constant";
import CompanyInfo from "../components/Forms/CompanyInfo";
import SalesAddress from "../components/Forms/SalesAddress";
import Address from "../components/Forms/Address";
import Clientaccess from "../components/models/Clientaccess";
import RejectClient from "../components/models/RejectClient";
import PrimaryButton from "../components/Forms/PrimaryButton";
import CustomBadge from "../components/Charts/CustomBadge";
import { notificationRefresh, profileRefresh, resetCartState } from "../redux/auth/cartRefreshSlice";
import { handleRouteNav } from "../utils";
import { resetNavState } from "../redux/auth/navCountSlice";
import SearchInput from "../components/Forms/SearchInput";
import DataTable from "../components/Tables/Datatable";
import EmptySection from "../components/Layout/EmptySection";

const clientStatus = {
  approved: "approved",
  pending: "pending",
  rejected: "rejected",
};

export function getAddressModApiBody({ full_name, is_sales_manager, formData, pending_modification = {}, existingBody, is_customer, customer_id }) {
  let apiRoute;
  const body = { ...existingBody };

  if (is_sales_manager) {
    if (formData.type === "add") {
      apiRoute = "sales/address/add";
    } else if (formData.type === "delete") {
      apiRoute = "sales/address/delete";
    } else {
      apiRoute = "sales/address/update";
    }
  } else if (is_customer) {
    formData.customer_id = customer_id;
    if (formData.type === "add") {
      apiRoute = "address/add";
    } else if (formData.type === "delete") {
      apiRoute = "address/delete";
    } else {
      apiRoute = "address/update";
    }
  } else {
    const { customer_request_id, findAddress, findUpdateAddress, assigned_sales_person } = pending_modification;
    let foundAddress;
    if (findAddress && formData.address_id) {
      foundAddress = findAddress(formData.address_id);
    } else if (findUpdateAddress && formData.update_address_id) {
      foundAddress = findUpdateAddress(formData.update_address_id);
    } else {
      foundAddress = null;
    }

    body.user_id = assigned_sales_person;
    body.request_id = customer_request_id;
    body.request_title = modificationTitlesTags.updateTitle;
    body.tags = modificationTitlesTags.updateTags(full_name, formData.company_name);

    if (foundAddress) {
      apiRoute = "sales/address/update-modification";
      body.address_id = foundAddress.address_id;
      body.update_address_id = foundAddress.update_address_id;
      body.type = formData.type || "update";
      body.request_title = foundAddress.request_title;
      body.tags = foundAddress.tags;
      body.customer_id = customer_id;
    } else {
      apiRoute = "sales/address/add-modification";
      body.address_id = formData.address_id || 0;
      body.type = formData.type || "update";
      body.customer_id = customer_id;
    }
  }

  return { apiRoute, body };
}

const PendingContext = createContext();

const Profile = () => {
  const { getApi, postApi, loading } = useApiCall();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showPopup } = useGlobalModal();
  const location = useLocation();
  const [detail, setDetails] = useState({});
  const [actionType, setActionType] = useState(null);
  const [isDeleteModal, setIsDeleteModel] = useState(false);
  const [isCode, setIsCode] = useState(false);
  const [isEditLogin, setIsEditLogin] = useState(false);
  const [modelType, setModelType] = useState(null);
  const [isCompanyInfo, setIsCompanyInfo] = useState(false);
  const [isEditAddress, setIsEditAddress] = useState(false);
  const [editingAddress, setEditingAddress] = useState(null);
  const [editAddressType, setEditAddressType] = useState(null);
  const [officeAddress, setOfficeAddress] = useState(null);
  const [residentialAddress, setResidentialAddress] = useState(null);
  const [clientAddresses, setClientAddresses] = useState([]);
  const { full_name, user_id, is_sales_manager, is_admin, is_sales_person, is_agent, is_customer, role_id, customer_id, permission_ids } =
    useSelector((state) => state.auth);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isRejectModal, setIsRejectModal] = useState(false);
  const [rejectRemark, setRejectRemark] = useState("");
  const [salesList, setSalesList] = useState([]);
  const [salesPerson, setSalesPerson] = useState(null);
  const [pending_modification, setPendingModification] = useState({});
  const [isWarningShown, setIsWarningShown] = useState(false);
  const [isAssignedClientsOpen, setIsAssignedClientsOpen] = useState(false);
  const [assignedClients, setAssignedClients] = useState([]);
  const [assignedClientsSearch, setAssignedClientsSearch] = useState("");
  const [assignedClientsLoading, setAssignedClientsLoading] = useState(false);

  const {
    user_id: userId,
    routeType,
    from_modification,
    customer_request_id,
  } = location.state || {
    routeType: is_customer ? "client" : "sales",
    user_id: user_id,
  };

  let hasEditAccess = false;
  const canViewAllClients = permission_ids.includes(PERMISSION_IDS.VIEW_ALL_CLIENTS);
  const canViewAllSalespersons = permission_ids.includes(PERMISSION_IDS.VIEW_ALL_SALESPERSONS);
  const isOwnClientProfile = String(detail?.user_id ?? "") === String(user_id);
  const isOwnSalesProfile = String(userId ?? "") === String(user_id);

  if (routeType === "client") {
    if (from_modification || is_sales_manager || is_customer || is_admin) {
      hasEditAccess = !from_modification;
    } else if (is_sales_person && isOwnClientProfile && detail?.is_edit_allowed === 1) {
      hasEditAccess = true;
    }
  } else if (routeType === "user" || routeType === "sales") {
    if (is_sales_manager || is_admin) {
      hasEditAccess = true;
    }
  }

  const bottomButtons = [];

  if (routeType === "user" || is_customer) {
    bottomButtons.push("logout");
  } else if (is_sales_person && (routeType === "client" ? hasEditAccess : false)) {
    // nothing to push → stays empty
  } else if (((from_modification && pending_modification.bool) || detail.status === clientStatus.pending) && (is_sales_manager || is_admin)) {
    bottomButtons.push("approve", "reject");
  } else if (
    (!from_modification && (is_sales_manager || is_admin) && detail.status === clientStatus.approved) ||
    (routeType === "sales" && (is_sales_manager || is_admin))
  ) {
    bottomButtons.push("block");
  }

  const isUpdateClientRequest = pending_modification?.title === modificationTitlesTags.updateTitle;

  const handleLogout = () => {
    setIsDeleteModel(true);
    setActionType("Logout");
  };

  const accountDelete = () => {
    setIsDeleteModel(true);
    setActionType("accountDelete");
  };

  const handleCancel = () => {
    setIsDeleteModel(false);
    setIsCode(false);
    setIsEditLogin(false);
    setIsRejectModal(false);
    setIsModalVisible(false);
    setIsCompanyInfo(false);
    setIsEditAddress(false);
    setIsAssignedClientsOpen(false);
  };

  const getClientLocation = (client) => {
    const defaultDelivery = client?.customer_address?.find((addr) => addr.is_default_delivery === 1);
    const city = defaultDelivery?.city || client?.city || "";
    const state = defaultDelivery?.state || client?.state || "";
    if (!city && !state) return "-";
    return `${city}${city && state ? ", " : ""}${state}`;
  };

  const fetchAssignedClients = async () => {
    if (!detail?.customer_id || !detail?.is_agent) return;

    setAssignedClientsLoading(true);
    try {
      const payload = {
        ...(is_sales_person && { user_id }),
        ...(detail?.is_agent && { agent_customer_id: detail.customer_id }),
      };

      const response = await postApi(detail?.is_agent ? "sales/agent/agent-customer-list" : "sales/assign-customer-list", payload);

      const formatted = (response?.data || [])
        .filter((item) => item.is_agent === 0)
        .map((item, index) => ({
          ...item,
          key: item.customer_id || item.id || index + 1,
          location: getClientLocation(item),
        }));

      setAssignedClients(formatted);
    } catch (error) {
      console.error("Error fetching assigned clients:", error);
      setAssignedClients([]);
    } finally {
      setAssignedClientsLoading(false);
    }
  };

  useEffect(() => {
    if (isAssignedClientsOpen) {
      setAssignedClientsSearch("");
      fetchAssignedClients();
    }
  }, [isAssignedClientsOpen, detail?.customer_id, detail?.is_agent]);

  const filteredAssignedClients = useMemo(() => {
    const value = assignedClientsSearch.toLowerCase().trim();
    if (!value) return assignedClients;
    return assignedClients.filter((client) => {
      const location = String(client.location || getClientLocation(client)).toLowerCase();
      return (
        String(client.company_name || "")
          .toLowerCase()
          .includes(value) ||
        String(client.email || "")
          .toLowerCase()
          .includes(value) ||
        String(client.phone || "")
          .toLowerCase()
          .includes(value) ||
        location.includes(value)
      );
    });
  }, [assignedClients, assignedClientsSearch]);

  const fetchAddresses = async (customer_id) => {
    if (!customer_id) return;
    try {
      const response = await postApi(is_customer ? "address" : "sales/address/list", {
        customer_id: customer_id,
      });
      setClientAddresses(response.data || []);
    } catch (error) {
      console.error("Error fetching addresses:", error);
    }
  };

  const fetchIndividual = async () => {
    let res;
    if (routeType === "client" || is_customer) {
      const data = {
        customer_id: is_customer ? customer_id : userId,
      };
      res = await postApi("customer/get-profile", data);
      fetchAddresses(is_customer ? customer_id : userId);
    } else {
      const data = {
        user_id: userId,
      };
      res = await postApi("user/get-profile", data);
    }
    if (res && res.data) {
      if (res.data.is_blocked == 1 && (user_id === userId || is_customer)) {
        dispatch(profileRefresh());
        return;
      }
      if (routeType === "user") dispatch(profileRefresh()); // refresh logged-in user's profile to update it
      setDetails(res.data);
      setOfficeAddress(res.data?.user_address?.find((a) => a.address_type === "Office"));
      setResidentialAddress(res.data?.user_address?.find((a) => a.address_type === "Residential"));
    } else if (res && !res?.status) {
      showPopup({
        title: null,
        content: <span className="custom-modal-title">{res.message}</span>,
        onOk: () => ((routeType === "user" && userId === user_id) || is_customer ? logoutUser() : navigate(-1)),
        className: "custom-success-modal",
      });
      if ((routeType === "user" && userId === user_id) || is_customer) {
        logoutUser();
      }
    }
  };

  const logoutUser = () => {
    dispatch(resetNavState());
    dispatch(resetCartState());
    dispatch(resetData());
    dispatch(resetState());

    localStorage.clear();
    sessionStorage.clear();

    navigate(handleRouteNav("/login", role_id));
  };

  useEffect(() => {
    fetchIndividual();
  }, [userId, routeType]);

  const handleBlock = () => {
    setIsDeleteModel(true);
    setActionType("Block");
  };

  const handleDeleteOk = async () => {
    if (actionType == "Block" && routeType == "sales") {
      const res = await postApi(
        "user/block-unblock-status",
        {
          is_blocked: detail?.is_blocked ? 0 : 1,
          updated_by: full_name,
          updated_by_id: user_id,
          user_id: userId,
        },
        true,
      );
      if (res && res?.status) {
        setIsDeleteModel(false);
        fetchIndividual();
      }
    } else if (actionType == "Block" && routeType == "client") {
      const res = await postApi(
        "sales/customers/block-unblock-status",
        {
          is_blocked: detail?.is_blocked ? 0 : 1,
          updated_by: full_name,
          updated_by_id: user_id,
          customer_id: userId,
        },
        true,
      );
      if (res && res?.status) {
        setIsDeleteModel(false);
        fetchIndividual();
      }
    } else if (actionType == "Logout") {
      setTimeout(() => {
        navigate(handleRouteNav("/login", role_id));
      }, 200);
      dispatch(resetState());
      dispatch(resetData());
      dispatch(resetCartState());
    } else if (actionType == "Address") {
      let { apiRoute, body } = getAddressModApiBody({
        full_name,
        is_sales_manager: is_sales_manager || is_admin,
        formData: {
          ...editingAddress,
          type: "delete",
        },
        pending_modification,
        existingBody: {
          ...editingAddress,
          updated_by: full_name,
          updated_by_id: user_id,
        },
        is_customer: is_customer,
        customer_id: detail.customer_id,
      });
      const res = await postApi(apiRoute, body, true);
      if (res && res?.status) {
        setIsDeleteModel(false);
        setEditingAddress(null);
        fetchIndividual();
        setIsWarningShown(true);
      }
    } else if (actionType == "UndoChanges") {
      let message = null;

      const originalDefaultDelivery = clientAddresses?.find((addr) => addr.is_default_delivery === 1);
      const originalDefaultBilling = clientAddresses?.find((addr) => addr.is_default_billing === 1);

      const isOriginalDeliveryInNew = pending_modification?.addresses?.some((addr) => addr.address_id === originalDefaultDelivery?.address_id);

      const isOriginalBillingInNew = pending_modification?.addresses?.some((addr) => addr.address_id === originalDefaultBilling?.address_id);

      const deliveryCond =
        editingAddress?.is_default_delivery === 1 && isOriginalDeliveryInNew && editingAddress?.address_id !== originalDefaultDelivery?.address_id;

      const billingCond =
        editingAddress?.is_default_billing === 1 && isOriginalBillingInNew && editingAddress?.address_id !== originalDefaultBilling?.address_id;

      if (deliveryCond && billingCond) {
        message = `Must have one default billing & delivery address`;
      } else if (deliveryCond) {
        message = `Must have one default ${"delivery"} address`;
      } else if (billingCond) {
        message = `Must have one default ${"billing"} address`;
      }

      if (message) {
        return showPopup({
          title: null,
          content: <span className="custom-modal-title">{message}</span>,
          onOk: () => console.log("Confirmed!"),
          className: "custom-success-modal",
        });
      }

      let apiRoute = "sales/address/delete-modification",
        body = {
          update_address_id: editingAddress?.update_address_id,
        };

      const res = await postApi(apiRoute, body, true);
      if (res && res?.status) {
        setIsDeleteModel(false);
        setEditingAddress(null);
        fetchIndividual();
        setIsWarningShown(true);
      }
    } else if (actionType == "ApproveChanges") {
      handleModApproveReject("approved", null, true);
    } else if (actionType == "accountDelete") {
      let apiRoute = "customer/delete",
        body = {
          customer_id: customer_id,
        };
      const res = await postApi(apiRoute, body, true);
      if (res && res?.status) {
        setIsDeleteModel(false);
        setTimeout(() => {
          navigate(handleRouteNav("/login", role_id));
        }, 200);
        dispatch(resetState());
        dispatch(resetData());
        dispatch(resetCartState());
      }
    }
  };

  const handleCode = (Type) => {
    setModelType(Type);
    setIsCode(true);
  };

  const handlepartyCode = async (values) => {
    let res;
    if (modelType == variableType.codeName) {
      values["party_code"] = Number(values.party_code);
      res = await postApi(
        "sales/customers/add-update-party-code",
        {
          ...values,
          updated_by: full_name,
          updated_by_id: user_id,
          customer_id: userId,
        },
        true,
      );
    } else if (modelType == variableType.passwordName) {
      if (routeType == "user" || routeType == "sales") {
        res = await postApi(
          "user/change-password",
          {
            ...values,
            user_id: userId,
          },
          true,
        );
      } else if (routeType == "client") {
        const { title, tags } = pending_modification;
        const companyInfoSource = pending_modification?.bool ? pending_modification?.modified_data || {} : detail || {};
        const apiRoute =
          is_sales_manager || is_admin || is_customer ? "customer/change-password" : "sales/customers/add-update-modification-pwd-request";

        const body =
          is_sales_manager || is_admin || is_customer
            ? {
                ...values,
                customer_id: is_customer ? customer_id : userId,
              }
            : {
                password: values.new_password,
                updated_by: full_name,
                updated_by_id: user_id,
                customer_id: userId,
                title: title || modificationTitlesTags.updateTitle,
                tags: tags || `Client update request by ${full_name} for client ${detail.company_name}`,
                request_id: pending_modification.customer_request_id || 0,
                customer_update_id: pending_modification.customer_update_id || 0,
                user_id: pending_modification.assigned_sales_person,
                zone: companyInfoSource?.zone,
                area: companyInfoSource?.area,
                agent_name: companyInfoSource?.agent_name,
                agent_remark: companyInfoSource?.agent_remark,
              };

        res = await postApi(apiRoute, body, true);
      }
    }
    if (res && res?.status) {
      setIsCode(false);
      fetchIndividual();
      setIsWarningShown(true);
    }
  };

  const handleEditLogin = () => {
    setIsEditLogin(true);
  };

  const handleEditDetails = async (values) => {
    let res = await postApi(
      "user/update-login-details",
      {
        user_id: userId,
        email: values.email,
        phone: values.phone,
      },
      true,
    );
    if (res && res?.status) {
      setIsEditLogin(false);
      fetchIndividual();
    }

    return res?.status;
  };

  const handleEditAddress = (type) => {
    setEditAddressType(type);
    setIsEditAddress(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleSuccess = () => {
    setRejectRemark("");
    if (from_modification) {
      navigate(handleRouteNav("/modifications", role_id));
    } else {
      navigate(handleRouteNav("/pending-clients", role_id));
    }
    setIsModalVisible(false);
    handleCancel();
  };

  const handleModApproveReject = async (type, rejectRemark, showResponse = true) => {
    let apiRoute,
      body = {
        updated_by: full_name,
        updated_by_id: user_id,
        reject_comment: rejectRemark?.trim(),
        customer_id: detail.customer_id,
        user_id: salesPerson || detail.user_id,
      };
    if (type === "approved") {
      apiRoute = "sales/update-request-approved";
      body.request_id = pending_modification?.customer_request_id;
      if (pending_modification?.addresses?.length) {
        body.address_ids = pending_modification?.addresses?.map((addr) => addr.update_address_id);
      }
    } else {
      apiRoute = "sales/update-request-rejected";
      body.customer_request_id = pending_modification?.customer_request_id;
    }
    const res = await postApi(apiRoute, body, showResponse, null, handleSuccess);
    if (res?.status) {
      dispatch(notificationRefresh());
    }
    return res?.status;
  };

  const handleStatusChange = async (status = clientStatus.rejected, showResponse = true) => {
    try {
      if (!isUpdateClientRequest) {
        const apiRoute = "sales/customers/approve-rejected";

        const body = {
          updated_by: full_name,
          updated_by_id: user_id,
          reject_comment: rejectRemark?.trim(),
          customer_id: userId,
          status,
        };
        const res = await postApi(apiRoute, body, showResponse, null, handleSuccess);
        if (!res?.status) {
          return false;
        }
        // dispatch(notificationRefresh());
      }
      const res = await handleModApproveReject(status, rejectRemark, isUpdateClientRequest);
      return res;
    } catch (error) {
      console.log(error);
      return false;
    }
  };

  const fetchSalesList = async () => {
    const res = await getApi("sales/sales-person-dropdown-list");
    if (res && res.data) {
      setSalesList(res.data);
    }
  };

  useEffect(() => {
    if (!is_customer) {
      fetchSalesList();
    }

    if (routeType === "user" || is_customer) {
      dispatch(notificationRefresh());
    }
  }, []);

  const handleSelect = (id) => {
    setSalesPerson(id);
  };

  const handleSubmit = async () => {
    if (salesPerson === null || salesPerson === undefined) {
      return showPopup({
        title: null,
        content: <span className="custom-modal-title">Please select a sales person</span>,
        onOk: () => console.log("Confirmed!"),
        className: "custom-success-modal",
      });
    }

    let assignData = {
      user_id: salesPerson,
      customer_id: userId,
      updated_by: full_name,
      updated_by_id: user_id,
    };

    const res = await handleStatusChange(clientStatus.approved);
    if (!res) {
      return;
    }

    let response = await postApi("sales/assign-sales-person", assignData);

    if (response?.data || response?.status) {
      setIsModalVisible(false);
      fetchIndividual();
    }
  };

  const prevModsRef = useRef();

  const fetchMods = async () => {
    const response = await postApi("sales/modification-request-list", {
      customer_id: detail.customer_id,
      ...(customer_request_id ? { customer_request_id } : { status: "pending" }),
    });

    const reqs = response.data || [];

    if (reqs.length === 0 && customer_request_id && from_modification) {
      return showPopup({
        title: null,
        content: <span className="custom-modal-title">Data not found!</span>,
        onOk: () => navigate(-1),
        className: "custom-success-modal",
      });
    }

    const firstReq = reqs?.[0] || {};
    const firstCustomerData = firstReq?.customer_data?.[0] || {};
    const firstAddress = firstReq?.addresses?.[0] || {};
    const combined = [...(firstReq.customer_data || []), ...(firstReq.addresses || [])];

    const latest = combined.length > 0 ? combined.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))[0] : null;

    const hasUpdatedCompInfo = !!(
      firstCustomerData?.company_name ||
      firstCustomerData?.contact_person ||
      firstCustomerData?.email ||
      firstCustomerData?.phone ||
      firstCustomerData?.id_type ||
      firstCustomerData?.id_no
    );

    const currentMods = {
      customer_data: firstReq.customer_data || [],
      addresses: firstReq.addresses || [],
      status: latest?.status,
    };

    // call handleCancel if anything changed
    if (prevModsRef.current && JSON.stringify(prevModsRef.current) !== JSON.stringify(currentMods)) {
      handleCancel();
      fetchIndividual();
      // showPopup({
      //   title: null,
      //   content: <span className="custom-modal-title">A change has been made to this profile</span>,
      //   onOk: () => console.log("Confirmed!"),
      //   className: "custom-success-modal",
      // });
    }

    prevModsRef.current = currentMods;

    setPendingModification({
      bool: latest?.status === "pending",
      status: latest?.status,
      customer_data: firstReq?.customer_data || [],
      modified_data: firstCustomerData || {},
      hasUpdatedCompInfo,
      addresses: firstReq?.addresses || [],
      address_ids: firstReq?.addresses?.map((addr) => addr.address_id),
      findAddress: (addr_id) => firstReq?.addresses?.find((addr) => addr.address_id === addr_id), // bruh what did i just do, crazy!??
      findUpdateAddress: (addr_id) => firstReq?.addresses?.find((addr) => addr.update_address_id === addr_id),
      customer_request_id: firstReq?.customer_request_id || 0,
      customer_update_id: firstCustomerData?.customer_update_id || 0,
      title: firstCustomerData?.title || firstAddress?.request_title || "",
      tags: firstCustomerData?.tags || firstAddress?.tags || "",
      assigned_sales_person: detail.user_id,
    });
  };

  useEffect(() => {
    if (detail.customer_id && !is_customer) {
      fetchMods();
    }
  }, [detail]);

  useEffect(() => {
    if (pending_modification?.bool && !from_modification && !isWarningShown && isUpdateClientRequest && routeType === "client") {
      showPopup({
        title: null,
        content: <span className="custom-modal-title">A Modification request is pending for this client.</span>,
        onOk: () => console.log("Confirmed!"),
        className: "custom-success-modal",
      });
      setIsWarningShown(true);
    }
  }, [pending_modification, is_sales_manager, is_admin, from_modification, isWarningShown, isUpdateClientRequest, routeType]);

  const { setTitle, setDescription, setBackButton } = useOutletContext();

  useEffect(() => {
    setTitle(null);
    setDescription(null);
    setBackButton(true);
  }, [setTitle, setDescription, setBackButton, navigate]);

  return (
    <>
      <>
        <div className="pr-16 pl-4 pb-5">
          <Flex vertical gap={20}>
            <div className="bg-[#ffffff] p-6 rounded-3xl border border-[#D9D9D9]">
              <div className="flex gap-5 justify-between items-center">
                <div className="flex items-center gap-6">
                  <div className="rounded-3xl bg-[#F4F4F4] py-2 px-2">
                    <img src="../../assets/icons/welcome-logo.png" alt="badge" className="min-h-[64px] min-w-[64px] " />
                  </div>
                  <p className="text-[#000000] leading-7 text-left text-base">
                    {routeType !== "client" ? (
                      <>
                        <strong className="text-[24px]">{detail?.full_name}</strong>
                        <br />
                        {detail?.designation}
                      </>
                    ) : (
                      <>
                        <strong className="text-[24px]">{detail?.company_name}</strong>
                        <br />
                        Assigned Sales - {detail?.user?.full_name || "Not Assigned"}
                      </>
                    )}
                  </p>
                </div>
                <div className="flex items-center justify-end gap-2">
                  {from_modification ? (
                    <div className="flex flex-wrap gap-3 justify-end">
                      {pending_modification?.modified_data?.password && <CustomBadge text="Password modified" variant="blue" />}
                      {pending_modification?.status === "pending" ? (
                        <CustomBadge variant="pending" text="Request Pending" />
                      ) : pending_modification?.status === "rejected" ? (
                        <CustomBadge variant="danger" text="Request Rejected" />
                      ) : pending_modification?.status === "approved" ? (
                        <CustomBadge variant="success" text="Request Approved" />
                      ) : null}
                    </div>
                  ) : (
                    (hasEditAccess || routeType === "user") && (
                      <PrimaryButton text="Change Password" onClick={() => handleCode(variableType.passwordName)} btnType="secondary" />
                    )
                  )}
                  {(routeType !== "client" && hasEditAccess) || routeType === "user" ? (
                    <>
                      <PrimaryButton text="Edit Login Details" onClick={handleEditLogin} noIcon />
                    </>
                  ) : null}
                </div>
              </div>
            </div>
            {/* OG company info */}
            {(from_modification ? (pending_modification?.bool && isUpdateClientRequest) || !isUpdateClientRequest : true) && (
              <div className="bg-[#ffffff] p-6 rounded-3xl border border-[#D9D9D9]">
                <div className="flex gap-5 justify-between items-center">
                  <div className="w-[55%] flex items-center gap-6">
                    <p className="text-[#000000] leading-7 text-left text-base">
                      <strong className="text-[24px]">Company Information</strong>
                    </p>
                  </div>
                  {hasEditAccess && (is_sales_manager || is_admin || !pending_modification?.hasUpdatedCompInfo) && (
                    <PrimaryButton text="Edit" icon={<MdOutlineEdit fontSize={"20px"} />} onClick={() => setIsCompanyInfo(true)} iconOnleft />
                  )}
                </div>
                <Flex vertical gap={36} className="py-8">
                  <Flex justify="space-between">
                    <InfoCard
                      icon={<PiBriefcaseFill className="text-[#A33434]" size={24} />}
                      label={routeType == "client" ? "Company Name" : "Employee Name"}
                      title={routeType == "client" ? detail?.company_name : detail?.full_name}
                    />
                    <InfoCard
                      icon={
                        routeType == "client" ? (
                          <PiUserFill className="text-[#A33434]" size={24} />
                        ) : (
                          <PiChatTextFill className="text-[#A33434]" size={24} />
                        )
                      }
                      label={routeType == "client" ? "Contact Person" : "Remarks"}
                      title={routeType == "client" ? detail?.contact_person : detail?.remark || "None"}
                    />
                  </Flex>
                  <Flex justify="space-between">
                    <InfoCard
                      icon={<PiEnvelopeFill className="text-[#A33434]" size={24} />}
                      label={routeType == "client" ? "Email Address" : "Display Email Address"}
                      title={routeType == "client" ? detail?.email : detail?.display_email_address}
                    />
                    <InfoCard
                      icon={<PiPhoneFill className="text-[#A33434]" size={24} />}
                      label={routeType == "client" ? "Phone" : "Display Phone No."}
                      title={detail?.display_contact_no ? detail?.display_contact_no : "+91" + " " + detail?.phone}
                    />
                  </Flex>
                  <Flex justify="space-between">
                    <InfoCard
                      icon={<PiIdentificationCardFill className="text-[#A33434]" size={24} />}
                      label={"ID Type"}
                      title={detail?.id_type || "None"}
                    />
                    <InfoCard
                      icon={<PiHashFill className="text-[#A33434]" size={24} />}
                      label={"ID Number"}
                      title={(routeType == "client" ? detail?.id_no : detail?.id_number) || "None"}
                    />
                  </Flex>
                  <Flex justify="space-between">
                    <InfoCard icon={<PiMapPinSimpleLineFill className="text-[#A33434]" size={24} />} label={"Zone"} title={detail?.zone || "None"} />
                    <InfoCard icon={<PiMapPinAreaFill className="text-[#A33434]" size={24} />} label={"Area"} title={detail?.area || "None"} />
                  </Flex>

                  {routeType == "client" && (
                    <>
                      <Flex justify="space-between">
                        <InfoCard
                          icon={<PiUserRectangleFill className="text-[#A33434]" size={24} />}
                          label={"Agent Name"}
                          title={(is_agent || detail.is_agent ? "SELF" : (detail?.agent_data?.company_name ?? detail?.agent_name)) || "Not Assigned"}
                          onInfo={(is_agent || detail?.is_agent) && !from_modification ? () => setIsAssignedClientsOpen(true) : undefined}
                          infoBtnTooltip="View Assigned Clients"
                        />
                        <InfoCard
                          icon={<PiChatTextFill className="text-[#A33434]" size={24} />}
                          label={"Remarks"}
                          title={detail?.agent_remark || "None"}
                        />
                      </Flex>
                    </>
                  )}
                </Flex>
              </div>
            )}
            {/* end of OG company info */}
            {/* This is teh modified info */}
            {(((is_sales_manager || is_admin) && from_modification) || is_sales_person) && pending_modification?.hasUpdatedCompInfo && (
              <div className="bg-[#ffffff] p-6 rounded-3xl border border-[#D9D9D9]">
                <div className="flex gap-5 justify-between items-center">
                  <div className="w-[55%] flex items-center gap-6">
                    <p className="text-[#000000] leading-7 text-left text-base">
                      <strong className="text-[24px]">Updated Company Information</strong>
                    </p>
                  </div>
                  {hasEditAccess && pending_modification?.hasUpdatedCompInfo && (
                    <PrimaryButton text="Edit" icon={<MdOutlineEdit fontSize={"20px"} />} onClick={() => setIsCompanyInfo(true)} iconOnleft />
                  )}
                </div>
                <Flex vertical gap={36} className="py-8">
                  <Flex justify="space-between">
                    <InfoCard
                      icon={<PiBriefcaseFill className="text-[#A33434]" size={24} />}
                      label="Company Name"
                      title={pending_modification?.modified_data?.company_name}
                    />
                    <InfoCard
                      icon={<PiUserFill className="text-[#A33434]" size={24} />}
                      label="Contact Person"
                      title={pending_modification?.modified_data?.contact_person}
                    />
                  </Flex>

                  <Flex justify="space-between">
                    <InfoCard
                      icon={<PiEnvelopeFill className="text-[#A33434]" size={24} />}
                      label="Email Address"
                      title={pending_modification?.modified_data?.email}
                    />
                    <InfoCard
                      icon={<PiPhoneFill className="text-[#A33434]" size={24} />}
                      label="Phone"
                      title={"+91 " + pending_modification?.modified_data?.phone}
                    />
                  </Flex>

                  <Flex justify="space-between">
                    <InfoCard
                      icon={<PiIdentificationCardFill className="text-[#A33434]" size={24} />}
                      label="ID Type"
                      title={pending_modification?.modified_data?.id_type}
                    />
                    <InfoCard
                      icon={<PiHashFill className="text-[#A33434]" size={24} />}
                      label="ID Number"
                      title={pending_modification?.modified_data?.id_no}
                    />
                  </Flex>

                  <Flex justify="space-between">
                    <InfoCard
                      icon={<PiMapPinSimpleLineFill className="text-[#A33434]" size={24} />}
                      label="Zone"
                      title={pending_modification?.modified_data?.zone || "None"}
                    />
                    <InfoCard
                      icon={<PiMapPinAreaFill className="text-[#A33434]" size={24} />}
                      label="Area"
                      title={pending_modification?.modified_data?.area || "None"}
                    />
                  </Flex>

                  <Flex justify="space-between">
                    <InfoCard
                      icon={<PiUserRectangleFill className="text-[#A33434]" size={24} />}
                      label="Agent Name"
                      title={
                        is_agent || detail?.is_agent
                          ? "SELF"
                          : (detail?.agent_data?.company_name ?? pending_modification?.modified_data?.agent_name) || "Not Assigned"
                      }
                    />
                    <InfoCard
                      icon={<PiChatTextFill className="text-[#A33434]" size={24} />}
                      label="Remarks"
                      title={pending_modification?.modified_data?.agent_remark || "None"}
                    />
                  </Flex>
                </Flex>
              </div>
            )}
            {/* End of modified info */}
            {/* OG addresses */}
            {(from_modification ? (pending_modification?.bool && isUpdateClientRequest) || !isUpdateClientRequest : true) && (
              <div className="bg-[#ffffff] text-[#000000] p-6 rounded-3xl border border-[#D9D9D9]">
                <div className="flex justify-between items-center mb-6">
                  <p className="text-left text-[#000000] text-[24px] font-bold leading-normal">Addresses</p>
                  {routeType === "client" &&
                    (is_sales_manager || is_admin || is_customer || (is_sales_person && !pending_modification?.addresses?.length)) &&
                    hasEditAccess && (
                      <PrimaryButton
                        text="Add New"
                        icon={<FiPlus />}
                        onClick={() => {
                          setIsEditAddress(true);
                          setEditingAddress({
                            type: "add",
                            customer_id: detail.customer_id,
                            company_name: detail.company_name,
                          });
                        }}
                        iconOnleft
                      />
                    )}
                </div>

                <div className="grid grid-cols-2 gap-4 pb-4">
                  {routeType !== "client" ? (
                    <>
                      <div className="rounded-2xl border border-[#D9D9D9] p-6 flex flex-col justify-between">
                        <div>
                          <div className="flex items-center gap-4">
                            <div className="w-[50px] h-[50px] bg-[#A334341A] flex justify-center items-center rounded-full">
                              <img src="../../assets/icons/address.png" alt="card-logo" />
                            </div>
                            <p className="text-xl font-bold break-words whitespace-normal">Residential address</p>
                          </div>
                          <p className="text-base text-left text-[#000000] leading-normal whitespace-pre-line mt-4">
                            {residentialAddress &&
                              residentialAddress?.address_line_1 +
                                "," +
                                " " +
                                residentialAddress?.address_line_2 +
                                "," +
                                " " +
                                residentialAddress?.city +
                                "," +
                                " " +
                                residentialAddress?.state +
                                "," +
                                " " +
                                residentialAddress?.postal_code +
                                "," +
                                " " +
                                "India"}
                          </p>
                        </div>
                        {(is_sales_manager || is_admin) && (
                          <div>
                            <div>
                              <Divider className="my-6" />
                            </div>
                            <div className="flex justify-center items-center">
                              <PrimaryButton
                                text="Edit"
                                icon={<MdOutlineEdit fontSize={"20px"} color="#fff" />}
                                onClick={() => handleEditAddress("residential")}
                                iconOnleft
                                btnType="ghost"
                              />
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="rounded-2xl border border-[#D9D9D9] p-6 flex flex-col justify-between">
                        <div>
                          <div className="flex items-center gap-4">
                            <div className="w-[50px] h-[50px] bg-[#A334341A] flex justify-center items-center rounded-full">
                              <img src="../../assets/icons/address.png" alt="card-logo" />
                            </div>
                            <p className="text-xl font-bold break-words whitespace-normal">Office address</p>
                          </div>
                          <p className="text-base text-left text-[#000000] leading-normal whitespace-pre-line mt-4">
                            {officeAddress &&
                              officeAddress?.address_line_1 +
                                "," +
                                " " +
                                officeAddress?.address_line_2 +
                                "," +
                                " " +
                                officeAddress?.city +
                                "," +
                                " " +
                                officeAddress?.state +
                                "," +
                                " " +
                                officeAddress?.postal_code +
                                "," +
                                " " +
                                "India"}
                          </p>
                        </div>
                        {(is_sales_manager || is_admin) && (
                          <div>
                            <div>
                              <Divider className="my-6" />
                            </div>
                            <div className="flex justify-center items-center">
                              <PrimaryButton
                                text="Edit"
                                icon={<MdOutlineEdit fontSize={"20px"} color="#fff" />}
                                onClick={() => handleEditAddress("office")}
                                iconOnleft
                                btnType="ghost"
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </>
                  ) : (
                    <>
                      {clientAddresses?.length > 0 ? (
                        clientAddresses.map((address) => (
                          <div className="rounded-2xl border border-[#D9D9D9] p-6 flex flex-col justify-between">
                            <div>
                              <div className="flex items-center gap-4">
                                <div className="w-[50px] h-[50px] bg-[#A334341A] flex justify-center items-center rounded-full">
                                  <img src="../../assets/icons/address.png" alt="card-logo" />
                                </div>
                                <div className="text-left">
                                  <p className="text-xl font-bold break-words whitespace-normal">{address.title}</p>
                                  {(address?.is_default_billing === 1 || address?.is_default_delivery === 1) && (
                                    <p className="text-sm break-words whitespace-normal">
                                      Default -{" "}
                                      <span className="font-semibold">
                                        {address?.is_default_billing && address?.is_default_delivery
                                          ? "Billing & Delivery"
                                          : address?.is_default_delivery
                                            ? "Delivery"
                                            : "Billing"}
                                      </span>
                                    </p>
                                  )}
                                </div>
                              </div>
                              <p className="text-base text-left text-[#000000] leading-normal whitespace-pre-line mt-4">
                                {address &&
                                  address?.address_line_1 +
                                    "," +
                                    " " +
                                    address?.address_line_2 +
                                    "," +
                                    " " +
                                    address?.city +
                                    "," +
                                    " " +
                                    address?.state +
                                    "," +
                                    " " +
                                    address?.postal_code +
                                    "," +
                                    " " +
                                    "India"}
                              </p>
                            </div>
                            {hasEditAccess &&
                              (is_sales_manager ||
                                is_admin ||
                                is_customer ||
                                (is_sales_person && !pending_modification?.address_ids?.includes(address.address_id))) && (
                                <div>
                                  <div>
                                    <Divider className="my-6" />
                                  </div>
                                  <div className="flex justify-center items-center">
                                    <PrimaryButton
                                      text="Edit"
                                      icon={<MdOutlineEdit fontSize={"20px"} color="#fff" />}
                                      onClick={() => {
                                        if (
                                          (address.is_default_billing === 1 || address.is_default_delivery === 1) &&
                                          is_sales_person &&
                                          pending_modification?.addresses?.length > 0
                                        ) {
                                          const message = `Submitting will make this your default ${
                                            address?.is_default_billing && address?.is_default_delivery
                                              ? "billing & delivery"
                                              : address?.is_default_delivery
                                                ? "delivery"
                                                : "billing"
                                          } address in updated addresses`;

                                          showPopup({
                                            title: null,
                                            content: <span className="custom-modal-title">{message}</span>,
                                            onOk: () => console.log("Confirmed!"),
                                            className: "custom-success-modal",
                                          });
                                        }
                                        setEditingAddress({
                                          ...address,
                                          company_name: detail.company_name,
                                          type: "update",
                                        });
                                        setIsEditAddress(true);
                                      }}
                                      iconOnleft
                                      btnType="ghost"
                                    />
                                    <Divider type="vertical" className="mx-6 h-12" />
                                    <PrimaryButton
                                      text="Delete"
                                      icon={<RiDeleteBin6Line fontSize={"20px"} color="#fff" />}
                                      onClick={() => {
                                        if (address.is_default_billing === 1 || address.is_default_delivery === 1) {
                                          showPopup({
                                            title: null,
                                            content: (
                                              <span className="custom-modal-title">
                                                {deleteDefaultAddressMsg(
                                                  address?.is_default_billing && address?.is_default_delivery
                                                    ? "billing & delivery"
                                                    : address?.is_default_delivery
                                                      ? "delivery"
                                                      : "billing",
                                                )}
                                              </span>
                                            ),
                                            onOk: () => console.log("Confirmed!"),
                                            className: "custom-success-modal",
                                          });
                                          return;
                                        }
                                        setEditingAddress({
                                          ...address,
                                          company_name: detail.company_name,
                                          type: "delete",
                                        });
                                        setIsDeleteModel(true);
                                        setActionType("Address");
                                      }}
                                      iconOnleft
                                      btnType="ghost"
                                    />
                                  </div>
                                </div>
                              )}
                          </div>
                        ))
                      ) : (
                        <p className="text-start font-semibold text-sm text-gray-500">No addresses found</p>
                      )}
                    </>
                  )}
                </div>
              </div>
            )}
            {/* end of OG addresses */}
            {/* updated addresses */}
            {(((is_sales_manager || is_admin) && from_modification) || is_sales_person) &&
              isUpdateClientRequest &&
              pending_modification?.addresses?.length > 0 &&
              routeType !== "user" && (
                <>
                  <div className="bg-[#ffffff] text-[#000000] p-6 rounded-3xl border border-[#D9D9D9]">
                    <div className="flex justify-between items-center mb-6">
                      <p className="text-left text-[#000000] text-[24px] font-bold leading-normal">Updated Addresses</p>
                      {routeType === "client" && hasEditAccess && (
                        <PrimaryButton
                          text="Add New"
                          icon={<FiPlus />}
                          onClick={() => {
                            setIsEditAddress(true);
                            setEditingAddress({
                              type: "add",
                              customer_id: userId,
                              company_name: detail.company_name,
                            });
                          }}
                          iconOnleft
                        />
                      )}
                    </div>
                    <div className="grid grid-cols-2 gap-4 pb-4">
                      {pending_modification?.addresses.map((address) => (
                        <div className="rounded-2xl border border-[#D9D9D9] p-6 flex flex-col justify-between relative">
                          <div className="absolute top-1 right-1 leading-normal">
                            <CustomBadge
                              text={
                                address.type === "add" ? "New" : address.type === "update" ? "Updated" : address.type === "delete" ? "Deleted" : null
                              }
                              variant={address.type === "add" ? "success" : address.type === "update" ? "pending" : "danger"}
                            />
                          </div>
                          <div className="pt-2">
                            <div className="flex items-center gap-4">
                              <div className="w-[50px] h-[50px] bg-[#A334341A] flex justify-center items-center rounded-full">
                                <img src="../../assets/icons/address.png" alt="card-logo" />
                              </div>
                              <div className="text-left">
                                <p className="text-xl font-bold break-words whitespace-normal">{address.title}</p>
                                {(address?.is_default_billing === 1 || address?.is_default_delivery === 1) && (
                                  <p className="text-sm break-words whitespace-normal">
                                    Default -{" "}
                                    <span className="font-semibold">
                                      {address?.is_default_billing && address?.is_default_delivery
                                        ? "Billing & Delivery"
                                        : address?.is_default_delivery
                                          ? "Delivery"
                                          : "Billing"}
                                    </span>
                                  </p>
                                )}
                              </div>
                            </div>
                            <p className="text-base text-left text-[#000000] leading-normal whitespace-pre-line mt-4">
                              {address &&
                                address?.address_line_1 +
                                  "," +
                                  " " +
                                  address?.address_line_2 +
                                  "," +
                                  " " +
                                  address?.city +
                                  "," +
                                  " " +
                                  address?.state +
                                  "," +
                                  " " +
                                  address?.postal_code +
                                  "," +
                                  " " +
                                  "India"}
                            </p>
                          </div>
                          {hasEditAccess && (
                            <div>
                              <div>
                                <Divider className="my-6" />
                              </div>
                              <div className="flex justify-center items-center">
                                {(address.type === "update" || address.type === "add") && (
                                  <>
                                    <PrimaryButton
                                      text="Edit"
                                      icon={<MdOutlineEdit fontSize={"20px"} color="#fff" />}
                                      onClick={() => {
                                        setEditingAddress({
                                          ...address,
                                          company_name: detail.company_name,
                                        });
                                        setIsEditAddress(true);
                                      }}
                                      iconOnleft
                                      btnType="ghost"
                                    />
                                    <Divider type="vertical" className="mx-6 h-12" />
                                  </>
                                )}
                                <PrimaryButton
                                  text="Undo"
                                  icon={<MdOutlineUndo fontSize={"20px"} color="#fff" />}
                                  onClick={() => {
                                    setEditingAddress({
                                      ...address,
                                      company_name: detail.company_name,
                                    });
                                    setIsDeleteModel(true);
                                    setActionType("UndoChanges");
                                  }}
                                  iconOnleft
                                  btnType="ghost"
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              )}
            {/* end of updated addresses */}
            {/* Party code stuff */}
            {routeType === "client" && (
              <>
                {!is_customer && (
                  <>
                    <div className="bg-[#ffffff] p-4 rounded-3xl border border-[#D9D9D9]">
                      <div className="flex gap-5 justify-between items-center">
                        <div className="w-[54%] flex items-center gap-6">
                          <div className="rounded-3xl bg-[#F4F4F4] p-2">
                            <img src="/assets/icons/code.png" alt="badge" />
                          </div>
                          <p className="text-[#000000] leading-7 text-left text-base">
                            Party Code
                            <br />
                            <strong className="text-[20px]">{detail?.party_code ? detail?.party_code : "None"}</strong>
                          </p>
                        </div>
                        {(detail?.status == clientStatus.pending || is_admin) && (
                          <PrimaryButton
                            text={detail?.party_code ? "Change code" : "Enter code"}
                            icon={<MdOutlineEdit fontSize={"20px"} color="#fff" />}
                            onClick={() => handleCode(variableType.codeName)}
                            iconOnleft
                            btnType="ghost"
                          />
                        )}
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
            {/* end of party code */}
            <div className="flex gap-5 justify-between items-center my-10">
              <div className="w-full flex items-center justify-around">
                {bottomButtons.includes("approve") && (
                  <PrimaryButton
                    text={`Approve ${isUpdateClientRequest ? "Changes" : "Client"}`}
                    btnType="secondary"
                    onClick={async () => {
                      if (isUpdateClientRequest) {
                        setActionType("ApproveChanges");
                        setIsDeleteModel(true);
                      } else {
                        if (!detail?.party_code) {
                          showPopup({
                            title: null,
                            content: <span className="custom-modal-title">Please enter party code.</span>,
                            onOk: () => console.log("Confirmed!"),
                            className: "custom-success-modal",
                          });
                          return;
                        }
                        setIsModalVisible(true);
                      }
                    }}
                    noIcon
                  />
                )}

                {bottomButtons.includes("reject") && (
                  <PrimaryButton
                    text={`Reject ${isUpdateClientRequest ? "Changes" : "Client"}`}
                    btnType="secondary"
                    onClick={() => setIsRejectModal(true)}
                    noIcon
                  />
                )}

                {bottomButtons.includes("block") && (
                  <PrimaryButton text={detail?.is_blocked ? "Unblock Account" : "Block Account"} btnType="secondary" onClick={handleBlock} noIcon />
                )}
                {bottomButtons.includes("logout") && <PrimaryButton text="Log Out" btnType="secondary" onClick={handleLogout} noIcon />}
              </div>
            </div>
          </Flex>
          {is_customer && (
            <a className="text-[#a33434] underline font-bold" onClick={accountDelete}>
              Delete Account
            </a>
          )}
        </div>
      </>
      <PendingContext.Provider value={{ pending_modification, routeType }}>
        <Block
          open={isDeleteModal}
          onCancel={handleCancel}
          onConfirm={handleDeleteOk}
          loading={loading}
          title={
            actionType === "Block"
              ? `Do you want to ${detail?.is_blocked ? "unblock" : "block"} this account?`
              : actionType === "Address"
                ? "Do you want to delete this address?"
                : actionType === "modifiedAddress"
                  ? "Do you want to delete this address?"
                  : actionType === "ApproveChanges"
                    ? "Do you want to approve these changes?"
                    : actionType === "UndoChanges"
                      ? "Do you want to undo these changes?"
                      : actionType === "accountDelete"
                        ? "Do you want to delete your account?"
                        : "Do you want to Log Out?"
          }
          confirmText={
            actionType == "Block"
              ? detail?.is_blocked
                ? "Unblock Account"
                : "Block Account"
              : actionType == "Address" || actionType === "modifiedAddress"
                ? "Delete Address"
                : actionType === "ApproveChanges"
                  ? "Approve Changes"
                  : actionType === "UndoChanges"
                    ? "Undo Changes"
                    : actionType === "accountDelete"
                      ? "Delete Account"
                      : "Log Out"
          }
        />
        <Modal className="form-css-5" open={isCode} footer={null} onCancel={handleCancel}>
          <PartyCode
            modelType={modelType}
            handleSubmit={handlepartyCode}
            closeModal={() => setIsCode(false)}
            loading={loading}
            formData={{ party_code: detail.party_code }}
          />
        </Modal>
        <Modal
          className="form-css"
          open={isEditLogin}
          footer={null}
          onCancel={handleCancel}
          styles={{
            content: {
              display: "inline-block",
              minWidth: "450px",
            },
          }}
          width="auto"
          centered
        >
          <EditLogin
            detail={detail}
            handleSubmit={handleEditDetails}
            closeModal={() => setIsEditLogin(false)}
            loading={loading}
            routeType={routeType}
          />
        </Modal>
        <Modal className="form-css" open={isCompanyInfo} footer={null} onCancel={() => setIsCompanyInfo(false)}>
          <CompanyInfo
            title="Edit Company Information"
            formData={
              hasEditAccess && pending_modification?.hasUpdatedCompInfo && is_sales_person
                ? {
                    ...(pending_modification?.modified_data || {}),
                    user_id: pending_modification?.modified_data?.user?.user_id,
                    customer_id: pending_modification?.modified_data?.customer_id,
                    is_agent: detail?.is_agent,
                    agent_data: detail?.agent_data,
                  }
                : detail
            }
            closeModal={(values) => {
              setIsCompanyInfo(false);
            }}
            formType={routeType}
            handleSubmit={() => {
              fetchIndividual();
              setIsWarningShown(true);
            }}
          />
        </Modal>

        {/* Add/edit address modals */}
        <Modal className="form-css-5" open={isEditAddress && routeType !== "client"} footer={null} onCancel={() => setIsEditAddress(false)}>
          <SalesAddress
            // title={`Edit Address`}
            formData={{
              ...(editAddressType === "residential" ? residentialAddress : officeAddress),
              type: editAddressType,
            }}
            closeModal={() => {
              setIsEditAddress(false);
            }}
            handleSubmit={() => {
              fetchIndividual();
            }}
          />
        </Modal>
        <Modal
          className="form-css-5"
          open={isEditAddress && routeType === "client"}
          footer={null}
          onCancel={() => {
            setIsEditAddress((prev) => !prev);
          }}
        >
          <Address
            formData={editingAddress}
            handleSubmit={() => {
              fetchIndividual();
              setIsWarningShown(true);
            }}
            closeModal={() => setIsEditAddress(false)}
          />
        </Modal>
        <Modal className="form-css-2" open={isModalVisible} onOk={handleOk} footer={null} onCancel={() => setIsModalVisible(false)}>
          <Clientaccess
            plainOptions={salesList}
            handleSubmit={handleSubmit}
            handleSelect={handleSelect}
            salesPerson={salesPerson}
            closeModal={() => setIsModalVisible(false)}
            assignedSalesPerson={detail?.user?.full_name}
            title="Assign Salesperson"
            loading={loading}
          />
        </Modal>

        <Modal
          className="form-css-2 custom-modal cancel-modal"
          open={isRejectModal}
          footer={null}
          onCancel={handleCancel}
          centered
          bodyStyle={{
            backgroundImage: "radial-gradient(#d1d5db 1px, transparent 1px), radial-gradient(#d1d5db 1px, transparent 1px)",
            backgroundPosition: "0 0, 10px 10px",
            backgroundSize: "20px 20px",
          }}
        >
          <RejectClient
            setRejectRemark={setRejectRemark}
            rejectRemark={rejectRemark}
            loading={loading}
            title={`Reject ${isUpdateClientRequest ? "Changes" : "Client"}`}
            handleSubmit={() => handleStatusChange(clientStatus.rejected, true)}
          />
        </Modal>

        <Modal className="form-css" open={isAssignedClientsOpen} footer={null} onCancel={() => setIsAssignedClientsOpen(false)} width={820}>
          <div className="flex justify-between items-center">
            <h2 className="text-3xl font-semibold text-gray-800 font-abhaya m-0">Assigned Clients</h2>
          </div>

          <div className="mt-4">
            <SearchInput value={assignedClientsSearch} onChange={(e) => setAssignedClientsSearch(e.target.value)} placeholder="Search for clients" />
          </div>

          <div>
            {filteredAssignedClients.length > 0 ? (
              <>
                <DataTable
                  columns={[
                    {
                      title: "Company Name",
                      dataIndex: "company_name",
                      key: "company_name",
                      ellipsis: true,
                    },
                    {
                      title: "Email",
                      dataIndex: "email",
                      key: "email",
                      ellipsis: true,
                    },
                    {
                      title: "Phone",
                      dataIndex: "phone",
                      key: "phone",
                      ellipsis: true,
                      render: (value, record) => record?.display_contact_no || value || "-",
                    },
                    {
                      title: "Location",
                      dataIndex: "location",
                      key: "location",
                      ellipsis: true,
                    },
                  ]}
                  data={filteredAssignedClients}
                  Showpagination={false}
                  loading={assignedClientsLoading}
                  disableHover
                  className="transparent-table mt-6"
                  customEmptySection={<p className="text-center text-gray-500 my-10">Sorry, no clients found</p>}
                />
              </>
            ) : (
              <p className="text-center text-gray-500 my-10">Sorry, no clients found</p>
            )}
          </div>
        </Modal>
      </PendingContext.Provider>
    </>
  );
};

export function usePendingModification() {
  return useContext(PendingContext);
}

export default Profile;
